export const enum Verb {
  // attributes
  UpsertSubjectAttributeSingle = "UpsertSubjectAttributeSingle",
  UpsertSubjectAttributeMany = "UpsertSubjectAttributeMany",
  AppendSubjectAttributeSingle = "AppendSubjectAttributeSingle",

  // shapes
  DeleteShape = "delete-shape",
  Clear = "clear",
  UndoClear = "undo-clear",

  // deprecated - can be deleted?
  MakeData = "make-data",
  AppendData = "append-data",
  DeleteData = "delete-data",
  UpsertShape = "upsert-shape",

  // meta
  SetIsLocked = "SetIsLocked",
}
